import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Segment} from 'semantic-ui-react';
import {fetchBankAccountOrder, setBankAccountOrderStatus} from '../../actions/support';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography
} from "@material-ui/core";

const mapStateToProps = ({support}) => {
  return ({
    order: support.bankAccountsOrder,
    loading: support.loading,
  });
}

const mapStatuses = {
  new: 'Utworzono',
  in_progress: 'W trakcie',
  manual_verification_pending: 'W trakcie weryfikacji',
  completed: 'W trakcie weryfikacji',
  accepted: 'Zaakceptowano',
  rejected: 'Odrzucono',
};

const mapTypes = {
  individual: 'Osoba fizyczna',
  sole_proprietorship: 'Jednoosobowa działalność gospodarcza',
  company: 'Spółka lub fundacja',
};

const mapVerMethods = {
  fiberpay_transfer: 'Przelew weryfikacyjny',
  banqup: 'Dane konta bankowego',
};

// const DescriptionTable = ({order}) => (
//   <Table compact celled>
//     <Table.Header>
//       <Table.Row>
//         <Table.HeaderCell
//           colspan={6}
//           textAlign="center"
//         >{`ORDER #${order.code}`}</Table.HeaderCell>
//       </Table.Row>
//       <Table.Row>
//         <Table.HeaderCell>Kod</Table.HeaderCell>
//         <Table.HeaderCell>Status</Table.HeaderCell>
//         <Table.HeaderCell>Typ</Table.HeaderCell>
//         <Table.HeaderCell>Metoda weryfikacji</Table.HeaderCell>
//         <Table.HeaderCell>Updated at</Table.HeaderCell>
//       </Table.Row>
//     </Table.Header>
//     <Table.Body>
//       <Table.Row>
//         <Table.Cell>{order.code}</Table.Cell>
//         <Table.Cell>
//           {order.status.replaceAll("_", " ").toUpperCase()}
//         </Table.Cell>
//         <Table.Cell>{order.type.replaceAll("_", " ").toUpperCase()}</Table.Cell>
//         <Table.Cell>
//           {(order.provider || "")
//             .replaceAll("_", " ")
//             .toUpperCase()}
//         </Table.Cell>
//         <Table.Cell>
//           {(order.status || "")
//             .replaceAll("_", " ")
//             .toUpperCase()}
//         </Table.Cell>
//         <Table.Cell>{order.updatedAt}</Table.Cell>
//       </Table.Row>
//     </Table.Body>
//   </Table>
// );

const DescriptionTable = ({order}) => (
  <>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Kod zlecenia</TableCell>
          <TableCell>Typ</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Metoda weryfikacji</TableCell>
          <TableCell>Utworzono</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{order.code}</TableCell>
          <TableCell>{mapTypes[order.type]}</TableCell>
          <TableCell>{mapStatuses[order.status]}</TableCell>
          <TableCell>
            {mapVerMethods[order.provider] || (
              <i>nie wybrano</i>
            )}
          </TableCell>
          <TableCell>{order.createdAt}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </>
);

const mapParamsName = {
  firstName: 'Imię',
  lastName: 'Nazwisko',
  companyName: 'Nazwa podmiotu',
  nip: 'NIP'
}


const ParamsTable = ({order}) => {
  const {params} = order;

  return (
    <>
      <Box my={2}>
        <Paper variant='outlined'>
          <Toolbar>
            <Typography>Parametry zlecenia</Typography>
          </Toolbar>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Parametr</TableCell>
                  <TableCell>Wartość</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  Object.entries(params).map(([key, value]) => (
                    <TableRow>
                      <TableCell>{mapParamsName[key]}</TableCell>
                      <TableCell>{value}</TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      {order.providedIdentity && (
        <Box my={2}>
          <Paper variant='outlined'>
            <Toolbar>
              <Typography>Dane {order.provider === 'fiberpay_transfer' ? 'przelewu weryfikacyjnego' : 'konta bankowego'}</Typography>
            </Toolbar>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Zweryfikowana tożsamość</TableCell>
                    <TableCell>{order.providedIdentity}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      )}
    </>
  )
}

const ContractorTable = ({order}) => {
  if (!order.contractor) {
    return <Segment>Verification transfer data not available yet</Segment>;
  }

  return (
    <Table>
      <Table.Header>
        <Table.HeaderCell colSpan={2} textAlign="center">
          VERIFICATION TRANSFER DATA
        </Table.HeaderCell>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell width={8}>CONTRACTOR IBAN</Table.Cell>
          <Table.Cell>{order.contractor.iban}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>CONTRACTOR NAME</Table.Cell>
          <Table.Cell>{order.contractor.name}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

const SupportBankAccountOrderDetails = ({order, code, fetchOrder, setOrderStatus}) => {
  const [loading, setLoading] = useState(true);
  const handleAccept = () => setOrderStatus(order.code, "accepted");
  const handleReject = () => setOrderStatus(order.code, "rejected");

  useEffect(() => {
    setLoading(true);
    fetchOrder(code);
  }, [code]);

  useEffect(() => {
    if (order?.code === code) setLoading(false);
  }, [order, code]);

  if (loading) {
    return <Segment basic loading style={{height: "80vh"}}/>;
  }

  return (
    <>
      <DescriptionTable order={order}/>
      <ParamsTable order={order}/>
      {order.status === 'manual_verification_pending' && (
        <Box textAlign={'justify-content'}>
          <Button onClick={handleAccept} color={'primary'} variant={'contained'} style={{marginRight: '16px'}} disableElevation>
            Akceptuj
          </Button>
          <Button onClick={handleReject}
                  color={'secondary'} variant={'outlined'}
                  type="submit"
          >
            Odrzuć
          </Button>

        </Box>
      )}
    </>
  )
};

const mapDispatchToProps = {fetchOrder: fetchBankAccountOrder, setOrderStatus: setBankAccountOrderStatus};

export default connect(mapStateToProps, mapDispatchToProps)(SupportBankAccountOrderDetails);
